import { ClipboardList } from 'lucide-react';
import type { ContactFormBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const contactFormConfig: BlockTypeConfig<ContactFormBlock> = {
  type: 'contact-form',
  label: 'Form',
  description: 'Configurable form with custom fields',
  icon: ClipboardList,
  category: 'interactive',
  createDefault: () => ({
    title: 'Get in touch',
    subtitle: '',
    fields: [
      {
        id: crypto.randomUUID(),
        type: 'text',
        label: 'Name',
        placeholder: 'Your name',
        required: true,
      },
      {
        id: crypto.randomUUID(),
        type: 'email',
        label: 'Email',
        placeholder: 'you@example.com',
        required: true,
      },
      {
        id: crypto.randomUUID(),
        type: 'textarea',
        label: 'Message',
        placeholder: 'How can we help?',
        required: true,
      },
    ],
    submitLabel: 'Send message',
    successMessage: "Thanks — we'll be in touch.",
  }),
  toolbar: [{ kind: 'variant' }, { kind: 'divider' }, { kind: 'more' }],
  sheet: [
    {
      kind: 'group',
      label: 'Heading',
      fields: [
        { kind: 'text', path: 'data.title', label: 'Title' },
        { kind: 'text', path: 'data.subtitle', label: 'Subtitle' },
      ],
    },
    {
      kind: 'group',
      label: 'Submission',
      fields: [
        { kind: 'text', path: 'data.submitLabel', label: 'Submit button label' },
        { kind: 'text', path: 'data.successMessage', label: 'Success message' },
        { kind: 'text', path: 'data.recipientEmail', label: 'Recipient email' },
      ],
    },
  ],
  repeatingItems: {
    arrayPath: 'data.fields',
    itemFactory: () => ({
      id: crypto.randomUUID(),
      type: 'text',
      label: 'New field',
      placeholder: '',
    }),
    addLabel: 'Add field',
  },
};
